import { FormatChartData } from "./FormatChartData";
import { FormatChartDataWithAverages } from "./FormatChartDataWithAverages";

export function ProcessChartData({
  aggregationKeys,
  groupBy,
  keys,
  priceKey,
  volumeKey,
  data,
  average = false,
}: {
  aggregationKeys: string[];
  groupBy: string[];
  keys: string[];
  priceKey: string;
  volumeKey: string;
  data: Array<Record<string, any>>;
  average?: boolean;
}): {
  keys: string[];
  keysLabels: string[];
  unit_keys: string[];
  group_by: Record<string, any[]>;

  data: Array<Record<string, any>>;
} {
  if (average) {
    return FormatChartDataWithAverages({
      aggregationKeys,
      groupBy,
      keys,
      priceKey,
      volumeKey,
      data,
    });
  } else {
    return FormatChartData({
      aggregationKeys,
      groupBy,
      keys,
      priceKey,
      volumeKey,
      data,
    });
  }
}
